import React, { FC, JSX } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { isPresent } from '@farmai-shared/LFUtils';
export const ProductionStatCard: FC<{
  title: string;
  printTitle: string;
  mainValue: JSX.Element;
  targetPerc: number | null | undefined;
  unit: string;
  testId?: string;
}> = observer(({
  title,
  mainValue,
  targetPerc,
  printTitle,
  unit,
  testId
}) => {
  const {
    t
  } = useTranslation();
  const isNegative = targetPerc && targetPerc < 0;
  const stringColor = isNegative ? 'text-negative-300' : 'text-positive-300';
  const percentageString = isNegative ? 'belowTarget' : 'aboveTarget';
  const caret = isNegative ? 'prod-stat-caret-down' : 'prod-stat-caret-up';
  const printPercentageNonZeroVal = t('productionPrintLower', {
    perc: targetPerc,
    direction: isNegative ? t('under') : t('above')
  });
  const printPercentageString = targetPerc === 0 ? t('noChangeToTarget') : printPercentageNonZeroVal;
  return <div className={`
        flex flex-col rounded-lg bg-white p-8
        print:mt-6 print:min-h-96 print:items-start print:justify-center print:rounded-4xl
        print:border print:border-silver print:px-12
      `}>
      <div className={`
          flex grow flex-col
          print:hidden
        `}>
        <div className={`
            flex flex-row items-center justify-between
            print:items-start
          `}>
          <p className="text-grey">{title}</p>
          <div className="flex justify-end">
            <div className={`
                rounded-full bg-white p-2
                print:hidden
              `}>
              <img src={'/static/assets/production-icon.svg'} />
            </div>
          </div>
        </div>

        <div data-testid={testId} className={`
            py-4 text-4xl whitespace-nowrap
            2xl:text-5xl
          `}>
          {mainValue}
        </div>
      </div>
      <div className={`
          hidden w-full text-center
          print:block print:text-start
        `}>
        <p className={`
            text-3xl font-light text-black
            print:text-4xl print:font-semibold print:text-silver
          `}>
          {t(printTitle)}
        </p>
        <div className={`
            print:text:5xl
            py-4 text-7xl
          `}>
          <div className={`
              flex justify-center gap-x-4
              print:block print:justify-start print:text-start print:font-semibold
            `}>
            {mainValue} <span>{unit}</span>
          </div>
        </div>
      </div>
      <div className={`
          hidden w-full border-b-2 border-b-grey p-4
          print:hidden
        `} />
      <div className={`
          flex justify-end
          print:mt-4 print:mr-auto print:ml-0 print:flex print:w-full print:justify-end
        `}>
        {isPresent(targetPerc) ? <div className={`
              flex items-center
              print:flex print:w-full print:justify-end
            `}>
            <div className={`
                flex items-center
                print:text-end print:text-2xl
              `}>
              <img src={`/static/assets/${caret}.svg`} className="print:mr-2" />
              <p className={`
                  ${stringColor}
                  ml-4
                  print:ml-2 print:text-3xl print:font-bold
                `}>
                {Math.abs(targetPerc)}% {t(percentageString)}
              </p>
            </div>
          </div> : null}
      </div>
      <div className={`
          hidden pt-8 font-light text-grey
          print:hidden
        `}>
        <p>{printPercentageString}</p>
      </div>
    </div>;
});